import { Message } from "../../chat";
import Bot from "../../assest/svg/Bot.svg";
import User from "../../assest/svg/User.svg";
import { useEffect, useRef } from "react";
import MarkdownIt from "markdown-it";
import markdownItHighlight from "markdown-it-highlightjs";
import File from "../../assest/svg/file.svg";
export const ChatBox = ({messages,chatBox}:{messages:Message[],chatBox:React.RefObject<HTMLDivElement>}) => {
  const decodeText = (inputText: string): string => {
    try {
      // Match the JSON object in the input text
  
      // Initialize MarkdownIt
      const md = MarkdownIt({
        html: true,
        linkify: true,
        typographer: true,
        breaks: true,
      }).use(markdownItHighlight);
  
      // Custom rule to open links in a new tab
      const defaultRender =
        md.renderer.rules.link_open ||
        ((tokens, idx, options, env, self) =>
          self.renderToken(tokens, idx, options));
  
      md.renderer.rules.link_open = (tokens, idx, options, env, self) => {
        const hrefIndex = tokens[idx].attrIndex("target");
  
        if (hrefIndex < 0) {
          tokens[idx].attrPush(["target", "_blank"]);
        } else {
          tokens[idx].attrs![hrefIndex][1] = "_blank";
        }
  
        return defaultRender(tokens, idx, options, env, self);
      };
  
      // Process and render Markdown
      const parts = inputText.split(/(```[\s\S]*?```)/g);
  
      const processedParts = parts.map((part) =>
        part.startsWith("```")
          ? part
          : part.replace(/\n\n/g, "\n&#8203;\n")
      );
  
      const processedInput = processedParts.join("");
      return md.render(processedInput, "markdown");
    } catch (error) {
      console.log(error);
      return `${error}`;
    }
  };
  
    useEffect(() => {
      setTimeout(() => {
        if (chatBox.current && messages.length) {
          chatBox.current.scroll({
            top: chatBox.current.scrollHeight,
            behavior: "smooth",
          });
        }
      }, 100);
    }, [messages]);
    return (
      <div className="flex-1 overflow-y-auto py-2 px-1 ">
      {messages.map((message, index) =>
        message.role === "user" ? (
          <div
            className="flex gap-2 items-end justify-center"
            key={index}
          >
            <div
              key={index}
              className={`p-2 rounded-lg ml-auto shadow-lg w-fit text-gray-800 max-w-[70%] ${
                message.role === "user"
                  ? "bg-[#ebf3fe] text-gray-800 dark:bg-gray-400/40 dark:text-white self-end "
                  : "bg-[#f9f9fb] text-black self-start"
              }`}
            >
              {/* {message.image_urls ? (
                <div className=" ">
                  <div className="flex gap-2">
                    {message.image_urls.map((file, index) => (
                      <div className="w-40 h-40 rounded-lg">
                        <img
                          className="w-full h-full align-middle rounded-lg"
                          src={i}
                          alt="image"
                        />
                      </div>
                    ))}
                  </div>
                  <div className="content mt-2">{message.content}</div>
                </div>
              ) : (
                <>{message.content}</>
              )} */}
              {message.image_urls ? (
                <div className="flex gap-2">
                  {message.image_urls.map((file, index) => {
                    const fileExtension = file
                      .split(".")
                      .pop()
                      ?.toLowerCase();
                      const isImage = [
                        "jpg",
                        "jpeg",
                        "png",
                        "gif",
                        "webp",
                        "docx",
                      ].includes(fileExtension ?? "");

                    return isImage ? (
                      <div className="w-40 rounded-lg" key={index}>
                        <img
                          className="w-full h-full align-middle rounded-lg"
                          src={file}
                          alt="image"
                        />
                      </div>
                    ) : (
                      <div
                        className="flex items-center justify-start w-40 rounded-lg p-2 bg-gray-100 dark:bg-slate-700 shadow-md"
                        key={index}
                      >
                        <img
                          src={File}
                          className="w-8 h-8  dark:invert"
                          alt="File"
                        />
                        <a
                          href={file}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-blue-500 text-sm truncate"
                        >
                          {file.split('/').pop().split('_').slice(-2).join('_')}
                        </a>
                      </div>
                    );
                  })}
                </div>
              ) : null}
              <div className="content mt-2">{message.content}</div>
            </div>
            <div className="bg-[#ebf3fe] p-2 rounded-lg shadow-lg dark:bg-gray-400/40 dark:text-white">
              <img
                src={User}
                className="w-6 max-w-6 dark:invert"
                alt="user"
              />
            </div>
          </div>
        ) : (
          <div
            key={index}
            className="flex justify-start items-end gap-2 text-gray-800 my-5"
          >
            {
              <div className="bg-[#f9f9fb] p-2 rounded-lg shadow-lg dark:bg-gray-400/40 dark:text-white">
                <img
                  src={Bot}
                  className="w-6 max-w-6 dark:invert"
                  alt="user"
                />
              </div>
            }
            <div
              key={message.content}
              className="w-full  p-2 shadow-lg rounded-md  bg-[#f9f9fb] dark:bg-gray-400/40 dark:text-white"
              dangerouslySetInnerHTML={{
                __html: decodeText(message.content),
              }}
            ></div>
          </div>
        )
      )}
    </div>
    )
}


